import React from 'react';
import memoize from 'memoize-one';
import { ButtonTooltip, DatatableEmployeeName, Icon } from '../../../components';
import Status from './Status';

const columns = memoize((clickHandler, employeeMenu) => [
  {
    name: 'Nombre del Colaborador',
    selector: 'name',
    cell: item => <DatatableEmployeeName item={item} name="name" withPhoto={false} withDot={false} />,
    sortable: true,
    minWidth: '185px',
    grow: '0.1'
  },
  {
    name: 'Fecha Inicio Turno',
    selector: 'date',
    grow: '2'
  },
  {
    name: 'Turno Asignado',
    selector: 'shift',
    cell: row =>
      row?.shift?.id ? (
        <>
          <p className="mt-0 mb-0">{row.shift.name}</p>
          {(row?.arrival?.length > 0 ||
            row?.arrival_break_time?.length > 0 ||
            row?.departure_break_time?.length > 0 ||
            row?.departure?.length > 0) &&
            employeeMenu[2] && (
              <>
                <ButtonTooltip
                  onClick={() => clickHandler(row, 'edit_shift')}
                  variant="circle-warning"
                  className="btn-circle"
                  size="sm"
                  text="Editar"
                >
                  <Icon icon="pencil" />
                </ButtonTooltip>
              </>
            )}
        </>
      ) : null,
    grow: 3
  },
  {
    name: 'Entrada',
    selector: 'arrival',
    minWidth: '165px',
    cell: item => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {item?.arrival?.length > 0 ? (
          item?.arrival?.map(arr => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span data-tag="allowRowEvents" className={arr.status === 2 ? '' : 'text-danger'}>
                {arr.clean_time ? arr.clean_time : '__:__:__'}
              </span>
              {arr.status === 2 && employeeMenu[2] && (
                <ButtonTooltip
                  onClick={() =>
                    clickHandler(
                      { ...item, time: arr.time, id: arr.id, parsedTime: arr.parsed_time, timeZone: arr.time_zone, branchOfficeId: arr.branch_office_id },
                      'edit_attendance',
                      'arrival'
                    )
                  }
                  variant="circle-warning"
                  className="btn-circle"
                  size="sm"
                  text="Editar"
                >
                  <Icon icon="pencil" />
                </ButtonTooltip>
              )}
              {employeeMenu[3] && (
                <ButtonTooltip
                  onClick={() =>
                    clickHandler(
                      { ...item, time: arr.time, id: arr.id, parsedTime: arr.parsed_time, timeZone: arr.time_zone, branchOfficeId: arr.branch_office_id },
                      'destroy_attendance',
                      'arrival'
                    )
                  }
                  variant={arr.status === 2 ? 'circle-danger' : 'circle-success'}
                  className="btn-circle"
                  size="sm"
                  text={arr.status === 2 ? 'Desactivar' : 'Activar'}
                >
                  <Icon icon={arr.status === 2 ? 'close-circle' : 'checkmark-circle'} />
                </ButtonTooltip>
              )}
            </div>
          ))
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span data-tag="allowRowEvents">__:__:__</span>
            <ButtonTooltip
              onClick={() =>
                clickHandler({ ...item, time: null, id: null, parsedTime: null, timeZone: null, branchOfficeId: null }, 'edit_attendance', 'arrival')
              }
              variant="circle-warning"
              className="btn-circle"
              size="sm"
              text="Editar"
            >
              <Icon icon="pencil" />
            </ButtonTooltip>
          </div>
        )}
      </div>
    ),
    grow: 3
  },
  {
    name: 'Entrada Colación',
    selector: 'arrival_break_time',
    minWidth: '165px',
    cell: item => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {item?.arrival_break_time?.length > 0 ? (
          item?.arrival_break_time?.map(arr => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span data-tag="allowRowEvents" className={arr.status === 2 ? '' : 'text-danger'}>
                {arr.clean_time ? arr.clean_time : '__:__:__'}
              </span>
              {arr.status === 2 && employeeMenu[2] && (
                <ButtonTooltip
                  onClick={() =>
                    clickHandler(
                      { ...item, time: arr.time, id: arr.id, parsedTime: arr.parsed_time, timeZone: arr.time_zone, branchOfficeId: arr.branch_office_id },
                      'edit_attendance',
                      'arrival_break_time'
                    )
                  }
                  variant="circle-warning"
                  className="btn-circle"
                  size="sm"
                  text="Editar"
                >
                  <Icon icon="pencil" />
                </ButtonTooltip>
              )}
              {employeeMenu[3] && (
                <ButtonTooltip
                  onClick={() =>
                    clickHandler(
                      { ...item, time: arr.time, id: arr.id, parsedTime: arr.parsed_time, timeZone: arr.time_zone, branchOfficeId: arr.branch_office_id },
                      'destroy_attendance',
                      'arrival_break_time'
                    )
                  }
                  variant={arr.status === 2 ? 'circle-danger' : 'circle-success'}
                  className="btn-circle"
                  size="sm"
                  text={arr.status === 2 ? 'Desactivar' : 'Activar'}
                >
                  <Icon icon={arr.status === 2 ? 'close-circle' : 'checkmark-circle'} />
                </ButtonTooltip>
              )}
            </div>
          ))
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span data-tag="allowRowEvents">{item?.shift?.lunch_check === true ? '__:__:__' : 'No Aplica'}</span>
            <ButtonTooltip
              onClick={() =>
                clickHandler(
                  { ...item, time: null, id: null, parsedTime: null, timeZone: null, branchOfficeId: null },
                  'edit_attendance',
                  'arrival_break_time'
                )
              }
              variant="circle-warning"
              className="btn-circle"
              size="sm"
              text="Editar"
            >
              <Icon icon="pencil" />
            </ButtonTooltip>
          </div>
        )}
      </div>
    ),
    grow: 3
  },
  {
    name: 'Salida Colación',
    selector: 'departure_break_time',
    minWidth: '165px',
    cell: item => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {item?.departure_break_time?.length > 0 ? (
          item?.departure_break_time?.map(arr => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span data-tag="allowRowEvents" className={arr.status === 2 ? '' : 'text-danger'}>
                {arr.clean_time ? arr.clean_time : '__:__:__'}
              </span>
              {arr.status === 2 && employeeMenu[2] && (
                <ButtonTooltip
                  onClick={() =>
                    clickHandler(
                      { ...item, time: arr.time, id: arr.id, parsedTime: arr.parsed_time, timeZone: arr.time_zone, branchOfficeId: arr.branch_office_id },
                      'edit_attendance',
                      'departure_break_time'
                    )
                  }
                  variant="circle-warning"
                  className="btn-circle"
                  size="sm"
                  text="Editar"
                >
                  <Icon icon="pencil" />
                </ButtonTooltip>
              )}
              {employeeMenu[3] && (
                <ButtonTooltip
                  onClick={() =>
                    clickHandler(
                      { ...item, time: arr.time, id: arr.id, parsedTime: arr.parsed_time, timeZone: arr.time_zone, branchOfficeId: arr.branch_office_id },
                      'destroy_attendance',
                      'departure_break_time'
                    )
                  }
                  variant={arr.status === 2 ? 'circle-danger' : 'circle-success'}
                  className="btn-circle"
                  size="sm"
                  text={arr.status === 2 ? 'Desactivar' : 'Activar'}
                >
                  <Icon icon={arr.status === 2 ? 'close-circle' : 'checkmark-circle'} />
                </ButtonTooltip>
              )}
            </div>
          ))
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span data-tag="allowRowEvents">{item?.shift?.lunch_check === true ? '__:__:__' : 'No Aplica'}</span>
            <ButtonTooltip
              onClick={() =>
                clickHandler(
                  { ...item, time: null, id: null, parsedTime: null, timeZone: null, branchOfficeId: null },
                  'edit_attendance',
                  'departure_break_time'
                )
              }
              variant="circle-warning"
              className="btn-circle"
              size="sm"
              text="Editar"
            >
              <Icon icon="pencil" />
            </ButtonTooltip>
          </div>
        )}
      </div>
    ),
    grow: 3
  },
  {
    name: 'Salida',
    selector: 'departure',
    minWidth: '165px',
    cell: item => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {item?.departure?.length > 0 ? (
          item?.departure?.map(arr => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', whiteSpace: 'nowrap' }}>
              <span data-tag="allowRowEvents" className={arr.status === 2 ? '' : 'text-danger'}>
                {arr.clean_time ? arr.clean_time : '__:__:__'}
              </span>
              {arr.status === 2 && employeeMenu[2] && (
                <ButtonTooltip
                  onClick={() =>
                    clickHandler(
                      { ...item, time: arr.time, id: arr.id, parsedTime: arr.parsed_time, timeZone: arr.time_zone, branchOfficeId: arr.branch_office_id },
                      'edit_attendance',
                      'departure'
                    )
                  }
                  variant="circle-warning"
                  className="btn-circle"
                  size="sm"
                  text="Editar"
                >
                  <Icon icon="pencil" />
                </ButtonTooltip>
              )}
              {employeeMenu[3] && (
                <ButtonTooltip
                  onClick={() =>
                    clickHandler(
                      { ...item, time: arr.time, id: arr.id, parsedTime: arr.parsed_time, timeZone: arr.time_zone, branchOfficeId: arr.branch_office_id },
                      'destroy_attendance',
                      'departure'
                    )
                  }
                  variant={arr.status === 2 ? 'circle-danger' : 'circle-success'}
                  className="btn-circle"
                  size="sm"
                  text={arr.status === 2 ? 'Desactivar' : 'Activar'}
                >
                  <Icon icon={arr.status === 2 ? 'close-circle' : 'checkmark-circle'} />
                </ButtonTooltip>
              )}
            </div>
          ))
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span data-tag="allowRowEvents">__:__:__</span>
            <ButtonTooltip
              onClick={() =>
                clickHandler({ ...item, time: null, id: null, parsedTime: null, timeZone: null, branchOfficeId: null }, 'edit_attendance', 'departure')
              }
              variant="circle-warning"
              className="btn-circle"
              size="sm"
              text="Editar"
            >
              <Icon icon="pencil" />
            </ButtonTooltip>
          </div>
        )}
      </div>
    ),
    grow: 3
  },

  {
    name: 'Estado',
    selector: 'status',
    cell: item => <Status status={item.status_attendances} />,
    sortable: true,
    grow: '1'
  },
  {
    name: 'Acciones',
    cell: item => (
      <>
        {employeeMenu[1] && (
          <ButtonTooltip
            onClick={() => clickHandler(item, 'show')}
            variant="circle-info"
            className="btn-circle"
            size="sm"
            text="Ver"
          >
            <Icon icon="eye" />
          </ButtonTooltip>
        )}
      </>
    ),
    ignoreRowClick: true,
    grow: '1',
    minWidth: '150px',
    center: true
  }
]);

export default columns;
